import React from "react";
import "./footer.css";
function Footer() {
  return (
    <div className="footer">
      Made By
      <a className="footerLink" href="https://github.com/NeerajSati">
        Neeraj Sati
      </a>
    </div>
  );
}

export default Footer;
